import React, { useState } from 'react';
import { Link as FakeLink, Card } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { shuffle, orderBy } from 'lodash';

import Affiliate from './Affiliate';
import AffiliatesModal from './AffiliatesModal';

const StyledCard = styled(Card)(({ theme }: any) => ({
  padding: theme.spacing(3),
  marginTop: theme.spacing(2),
  display: 'flex',
  alignItems: 'center',
  '& >:not(:last-child)': {
    marginRight: theme.spacing(1),
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    '& >:not(:last-child)': {
      marginRight: 0,
      marginBottom: theme.spacing(1),
    },
  },
  '& .MuiCardActionArea-focusHighlight, & .MuiTouchRipple-root': {
    borderRadius: theme.shape.borderRadius * 2,
  },
}));

const StyledFakeLink = styled(FakeLink)(({ theme }) => ({
  marginLeft: 'auto',
  flexShrink: 0,
  [theme.breakpoints.down('sm')]: {
    margin: `${theme.spacing(3)} auto 0`,
  },
}));

function SpaceAffiliatesList({ affiliates = [] }) {
  const intl = useIntl();
  const [modalOpen, setmodalOpen] = useState(false);

  if (!affiliates.length) return null;

  return (
    <>
      <StyledCard>
        {shuffle(affiliates)
          .slice(0, 3)
          .map((affiliate) => (
            <Affiliate affiliate={affiliate} key={affiliate.slug} />
          ))}

        {affiliates.length > 3 && (
          <StyledFakeLink
            onClick={() => setmodalOpen(true)}
            color="primary"
            component="button"
            variant="body1"
            underline="none"
          >
            <FormattedMessage
              id="SPACE.HOME.AFFILIATES.SEE_MORE"
              values={{ count: affiliates.length }}
            />
          </StyledFakeLink>
        )}
      </StyledCard>

      <AffiliatesModal
        affiliates={orderBy(affiliates, 'name')}
        open={modalOpen}
        onClose={() => setmodalOpen(false)}
        title={intl.formatMessage({ id: 'SPACE.HOME.AFFILIATES.AFFILIATED' })}
      />
    </>
  );
}

SpaceAffiliatesList.propTypes = {
  affiliates: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
      brand_logo: PropTypes.shape({
        s3_key: PropTypes.string,
      }),
    }).isRequired,
  ),
};

export default SpaceAffiliatesList;
